<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('role.action.set_policies') }}</div>
    <div slot="body">
      <dialog-selected-tips :name="$t('dictionary.role')" :count="params.data.length" :action="$t('role.action.set_policies')" />
      <dialog-table :data="params.data" :columns="columns" />
      <set-policies-form ref="setPoliciesForm" :data="params.data" />
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ submitButtonText }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import workflowMixin from '@/mixins/workflow'
import { WORKFLOW_TYPES } from '@/constants/workflow'
import { uuid } from '@/utils/utils'
import SetPoliciesForm from '../components/SetPolicies'

export default {
  name: 'RoleSetPoliciesDialog',
  components: {
    SetPoliciesForm,
  },
  mixins: [DialogMixin, WindowsMixin, workflowMixin],
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    columns () {
      return this.params.columns.filter(item => item.field === 'project_domain' || item.field === 'name')
    },
    isExecuteResourceOrderSetEnabled () {
      return this.checkWorkflowEnabled(WORKFLOW_TYPES.EXECUTE_ROLE_SET_POLICIES)
    },
    submitButtonText () {
      return this.isExecuteResourceOrderSetEnabled ? this.$t('system.text_532') : this.$t('dialog.ok')
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        // 如果启用了 execute-resource-order-set 工单类型，则创建工单
        if (this.isExecuteResourceOrderSetEnabled) {
          await this.setPoliciesByWorkflow()
        } else {
          // 否则直接设置策略
          await this.$refs.setPoliciesForm.set(this.params.data[0].id, this.params.setPoliciesAction)
          this.cancelDialog()
          this.params.success && this.params.success()
        }
      } finally {
        this.loading = false
      }
    },
    async setPoliciesByWorkflow () {
      try {
        const roleData = this.params.data[0]
        const roleId = roleData.id
        // 获取表单数据
        const formValues = await this.$refs.setPoliciesForm.form.fc.validateFields()
        const policies = []
        let ips
        if (formValues.ips) {
          ips = formValues.ips.split(',')
        }
        if (formValues.policies && formValues.policies.length) {
          for (let i = 0, len = formValues.policies.length; i < len; i++) {
            const item = {
              policy_id: formValues.policies[i],
            }
            if (ips) {
              item.ips = ips
            }
            if (formValues.project) {
              item.project_id = formValues.project
            }
            if (formValues.valid_since) {
              item.valid_since = formValues.valid_since
            }
            if (formValues.valid_until) {
              item.valid_until = formValues.valid_until
            }
            policies.push(item)
          }
        }
        // 获取项目和项目域信息
        const projectId = roleData.project_id || this.userInfo.projectId || ''
        const domainId = roleData.domain_id || this.userInfo.projectDomainId || 'default'
        const projectDomainName = roleData.project_domain || (domainId === 'default' ? 'Default' : domainId)

        // 创建 resource_order_sets
        const orderSetManager = new this.$Manager('resource_order_sets')
        const { displayname, name } = this.userInfo
        const orderSetData = {
          auto_execute: false,
          name: this.$t('iam.role_set_policies_workflow_name', [displayname || name, this.$moment().format('YYYY-MM-DD'), uuid()]),
          parameters: [{
            action: 'perform',
            perform_action_name: 'set-policies',
            resource: 'roles',
            resource_id: roleId,
            project: projectId || '',
            project_domain: projectDomainName,
            parameter: {
              policies,
              action: this.params.setPoliciesAction || 'replace',
            },
          }],
        }
        const orderSetRes = await orderSetManager.create({ data: orderSetData })

        // 创建工单
        const variables = {
          process_definition_key: WORKFLOW_TYPES.EXECUTE_ROLE_SET_POLICIES,
          initiator: this.userInfo.id,
          ids: orderSetRes.data.id,
          parameter: '{}',
          project: projectId || '',
          project_domain: domainId,
          execute_resource_order_set_type: 'roles_perform_set_policies',
        }
        await this.createWorkflow(variables)
        this.$message.success(this.$t('common.worflow_tip', [this.$t('role.action.set_policies')]))
        this.cancelDialog()
        this.$router.push('/workflow')
      } catch (error) {
        throw error
      }
    },
  },
}
</script>
